import React, { useRef, useState } from "react";
import { Button } from 'primereact/button';
import { apiRequest, publicUrl, url } from "@/Helpers/general";
import { Messages } from 'primereact/messages';
import PasswordInputTemplate from "@/Components/Templates/Forms/PasswordInputTemplate";
import { getFormErrorMessage, isFormFieldValid, validateForm } from "@/Helpers/forms";
import {Link} from "react-router-dom";
import TextInputTemplate from "@/Components/Templates/Forms/TextInputTemplate";

/**
 * Component which handles the user reset password
 *
 * @param {string} code needed for the password reset functionality
 */
const ResetPasswordForm = ({ code }) => {
    const initialFormData = {
        email: '',
        password: '',
        password_confirmation: ''
    };
    const messages = useRef();

    const [formData, setFormData] = useState(initialFormData);
    const [formErrors, setFormErrors] = useState({});
    const [formLoading, setFormLoading] = useState(false);
    const [successfullySent, setSuccessfullySent] = useState(false);

    /**
     * Update the state of the form data (when changing an input value)
     *
     * @param {string} name the name of the input
     * @param {string} value the new value of the input
     */
    const changeFormData = (name, value) => {
        let getFormData = { ...formData };

        getFormData[name] = value;

        setFormData(getFormData);
    };

    /**
     * Submits the reset password form
     */
    const submitForm = async () => {
        messages.current.clear();
        setFormLoading(true);

        let validation = validateForm([
            {
                field: 'email',
                rules: [{ name: 'email' }, { name: 'required' }]
            },
            {
                field: 'password',
                rules: [{
                    name: 'minLength',
                    params: { length: 16 }
                }, { name: 'required' }]
            },
            {
                field: 'password_confirmation',
                rules: [{
                    name: 'matchField',
                    params: { matchFieldName: 'password' }
                }, { name: 'required' }]
            }
        ], formData, setFormErrors);

        if (validation) {
            apiRequest('post', 'reset-pass-token', {
                data: {
                    token: code,
                    email: formData.email,
                    password: formData.password,
                    password_confirmation: formData.password_confirmation,
                },
                onSuccess: (response) => {
                    setFormLoading(false);

                    if (response.data) {
                        setSuccessfullySent(true);

                        messages.current.show({
                            severity: 'info',
                            detail: 'Your password has been successfully changed.',
                            sticky: true,
                            closable: false
                        });
                    }
                },
                onFailure: (error) => {
                    // messages.current.show({ severity: 'error', detail: error.messages ? error.messages : 'Server error', sticky: true });
                    setFormLoading(false);

                    if (error.status === 422) {
                        if (error.messages) {
                            let errorMessages = error.messages,
                                newFormErrors = {};

                            for (let key in errorMessages) {
                                if (Object.hasOwnProperty.call(errorMessages, key)) {
                                    newFormErrors[key] = errorMessages[key];
                                }
                            }

                            setFormErrors(newFormErrors);
                            // toast(toastRef, 'error', 'Error saving data.');

                        } else {
                            // toast(toastRef, 'error', 'Error saving data.');
                            messages.current.show({ severity: 'error', detail: error.messages ? error.messages : 'Server error', sticky: true });
                        }

                    } else {
                        // toast(toastRef, 'error', 'Error saving data.');
                        messages.current.show({ severity: 'error', detail: error.messages ? error.messages : 'Server error', sticky: true });
                    }
                }
            }, {
                noAuth: true
            });

        } else {
            setFormLoading(false);
        }
    };

    return (
        <>
            <Messages ref={messages}></Messages>

            {!successfullySent
                ? <div className="public-form">
                    <div className="text-center">
                        <h3>Reset password ?</h3>
                    </div>

                    <TextInputTemplate name="email" label="Email" value={formData.email} className="text-center"
                        autoComplete={"off"}
                        labelClassName="text-center w-11" floatLabel
                        onChangeFunction={changeFormData}
                        isValid={isFormFieldValid(formErrors, 'email')}
                        errorMessage={getFormErrorMessage(formErrors, 'email', true)}
                    />

                    <PasswordInputTemplate name="password" label="Password" value={formData.password} className="text-center" labelClassName="text-center w-11" floatLabel
                        autoComplete={"off"}
                        onChangeFunction={changeFormData}
                        isValid={isFormFieldValid(formErrors, 'password')}
                        errorMessage={getFormErrorMessage(formErrors, 'password', true)}
                    />

                    <PasswordInputTemplate name="password_confirmation" label="Confirm Password" value={formData.password_confirmation} className="text-center" labelClassName="text-center w-11" floatLabel
                        onChangeFunction={changeFormData}
                        isValid={isFormFieldValid(formErrors, 'password_confirmation')}
                        errorMessage={getFormErrorMessage(formErrors, 'password_confirmation', true)}
                    />

                    <div className="field mb-0">
                        <Button className="w-full block" label="Submit" onClick={submitForm} loading={formLoading} loadingIcon="pi pi-spin pi-sun" iconPos="center" />
                    </div>
                </div>

                : <div className="text-center">
                    <Link className="p-link" to={publicUrl('home')}>
                        <span>Login</span>
                    </Link>
                </div>
            }
        </>
    );
};

export default ResetPasswordForm;
